<template>
	<div class="container-fluid">
		<toolbar>
			<h2>Employers</h2>
		</toolbar>

		<ul v-if="employers && employers.length > 0" class="list-group">
			<li v-for="employer in employers" class="list-group-item">

				<div class="d-flex flex-row align-items-center justify-content-between">
					<div>
						<img v-if="'ProfileImage' in employer && employer.ProfileImage && 'slug' in employer.ProfileImage" class="employer-logo" :src="apiRoot+'resources/profile-images/'+employer.ProfileImage.slug+'/'+employer.ProfileImage.filename">
					</div>

					<div>
						<div><strong>{{employer.company_name}}</strong></div>
						<div class="text-muted">{{employer.address}}<span v-if="employer.province">,</span> {{employer.province}}<span v-if="employer.country">, {{employer.country}}</span></div>

					</div>
					<div class="ml-2 mr-2">
						<span :class="{'text-muted': employementStatusLabel(employer) != 'Offering Employment','text-success': employementStatusLabel(employer) == 'Offering Employment'}">
							<template v-if="employementStatusLabel(employer) == 'Offering Employment'">
								<i class="fa fa-exclamation"></i>
								<i class="fa fa-handshake"></i>
							</template>
							{{ employementStatusLabel(employer) }}
						</span>
					</div>

					<div v-if="employer.id == $store.userDetails.tenant_id" class="badge badge-primary">
						Active
					</div>
					<div v-else-if="employementStatusLabel(employer) == 'Offering Employment'">
						<button class="btn btn-primary" v-on:click="acceptEmployment(employer)">
							<i class="fa fa-handshake"></i>
							Accept Invite
						</button>
						<button class="btn btn-light" v-on:click="declineEmployment(employer)">
							<i class="fa fa-times"></i>
							Decline
						</button>
					</div>
					
					<button v-else class="btn btn-primary" v-on:click="activateEmployer(employer.id)">
						Activate
					</button>
				</div>

			</li>
		</ul>
		<div v-else class="text-center">
			<div class="alert alert-info">
				<h2>You have no employers :(</h2>

				<p>As a user on {{$store.appNameProper}}, you're meant to be connected to an employer. You can either get your company to invite you, or register your own company on {{$store.appNameProper}}</p>
			</div>
		</div>
		<div class="text-center mt-4">
			<button v-if="!showCompanyRegistration" class="btn btn-lg btn-primary" v-on:click="showCompanyRegistration = true">
				<i class="fa fa-plus"></i>
				Register a Company
			</button>

			<form v-if="showCompanyRegistration" 
				style="max-width: 600px;margin: auto;margin-top: 20px" 
				v-on:submit.prevent="registerCompany"
				class='text-center'>

				<h2>Register a Company on {{$store.appNameProper}}</h2>

				<field label="Company Name"
					col-class="col-md-4"
					v-model="registerPayload.company_name">
				</field>

				<p>Once your company is created you will be able to fill out your company profile</p>

				<button class="btn btn-success">
					<i class="fa fa-save"></i>
					Create Company
				</button>
			</form>
		</div>
	</div>
</template>
<script type="text/javascript">
import Toolbar from "../layout_fragments/Toolbar"
import Field from "@/components/Field"

export default {
	name: "Employers",
	components: {
		Toolbar,
		Field
	},
	data() {
		return {
			employers: [],
			apiRoot: window.apiRoot,
			showCompanyRegistration: false,
			registerPayload: {
				company_name: ""
			}
		}
	},
	computed: {

	},
	methods: {
		employementStatusLabel(employer) {
			if (employer.UserPermission[0].is_inactive == 1)
				return "Former Employer"
			else if (!employer.UserPermission[0].invite_accepted && employer.UserPermission[0].invite_declined == 0)
				return "Offering Employment"
			else
				return "Current Employer"
		},
		acceptEmployment(employer) {
			let vm = this

			let payload = {
				token: employer.UserPermission[0].slug
			}

			this.postData("CompanyUser/accept-employment",payload).then(response => {
				if (response.success) {
					vm.alertSuccess("Congratulations! You have accepted employment from "+employer.company_name)
					vm.fetchEmployers()
				}
			})
		},
		declineEmployment(employer) {
			let vm = this

			let payload = {
				token: employer.UserPermission[0].slug
			}

			this.postData("CompanyUser/decline-employment",payload).then(response => {
				if (response.success) {
					vm.alertSuccess("You have turned down employment from "+employer.company_name)
					vm.fetchEmployers()
				}
			})
		},
		activateEmployer(employer_id) {
			let vm = this

			let payload = {
				id: this.$store.userDetails.id,
				employer_id: employer_id
			}

			this.postData("User/save",payload,true).then(response => {
				vm.fetchEmployers()

				this.clearStore()

				if (!("id" in this.$store.userDetails))
					vm.$bus.$emit("logout")

				let token = ""
				try {
					token = JSON.parse(localStorage.sessionToken)

					token = token.token
				}
				catch (e) {}

				let params = {
					filters: [
						["token",token]
					]
				}

				this.getJSON("UserToken/get",params).then(response => {
					if (response.success && response.data.length > 0) {

						params = {
							include: ["UserPermission","JobPersonnelRole","CompanySettings"]
						}

			vm.getJSON("User/find/"+response.data[0].user_id,params).then(response =>{

						if (response.success) {
							if (response.data.UserPermission && response.data.UserPermission.length > 0) {
								response.data.UserPermission = response.data.UserPermission.filter(perm => perm.tenant_id == employer_id)
							}

							vm.$store.userDetails = response.data
							localStorage.userDetails = JSON.stringify(response.data)

							window.location.reload()
						}
					})
					}
				})
				
			})
		},
		registerCompany() {
			let vm = this

			this.postData("Company/create",this.registerPayload,true).then(response => {
				if (response.success) {
					vm.alertSuccess("Company registered!")

					vm.$store.userDetails.tenant_id = response.data.record_id

					vm.$store.company = {
						company_name: vm.registerPayload.company_name
					}

					//get user perms now
					vm.getJSON("UserPermission/get").then(response => {
						if (response.success) {
							vm.$store.userDetails.UserPermission = response.data

							localStorage.userDetails = JSON.stringify(vm.$store.userDetails)
						}
					})

					vm.$store.companySetupMode = true
					//vm.$router.push("/company/details")

					localStorage.companySetup = true

					setTimeout(() => {
						window.location = "/company/details" //need an actual refresh to reset menu state (we can fix this later)
					},500)
					//window.location = "/company/details" //need an actual refresh to reset menu state (we can fix this later)
				}	
			})
		},
		fetchEmployers() {
			let vm = this

			this.getJSON("Company/my-list",{},true).then(response => {
				vm.employers = response.data
			})
		}
	},
	created() {
		this.fetchEmployers()
	}
}
</script>

<style type="text/css" scoped>
	.list-group-item {
		vertical-align: top;
	}

	.employer-logo {
		width: 100%;
		max-width: 300px;
		margin-right: 10px;
	}
</style>